// Mirrors the Prisma enums of the same name (backend/prisma/schema/schema.prisma).
// Defined as const-object + literal-union so values are assignable from both the
// Prisma client enums and the generated frontend api types without casts.
export const ReportType = {
  standard: 'standard',
  notesReport: 'notesReport',
} as const;
export type ReportType = (typeof ReportType)[keyof typeof ReportType];

export const ReportCoverSheet = {
  simple: 'simple',
  withChart: 'withChart',
  withCustomImage: 'withCustomImage',
  withNote: 'withNote',
  withFlower: 'withFlower',
} as const;
export type ReportCoverSheet = (typeof ReportCoverSheet)[keyof typeof ReportCoverSheet];
